import { useState } from "react";
import { object } from "yup";
import * as yup from "yup";

const useRouteModal = () => {
  const validation = object({
    localId: yup.number().required("Selecione o local"),
  });

  const [initial, setinitial] = useState({
    localId: null,
  });

  return {
    validation,
    initial,
    setinitial,
  };
};

export default useRouteModal;
